import { Injectable } from '@angular/core';
import { GalleryItem } from 'ngx-simple-gallery';

@Injectable({
  providedIn: 'root',
})
export class GalleryService {
  private baseUrl = 'https://acabjj-gallery.s3.eu-central-1.amazonaws.com';

  public getDojoItems(): GalleryItem[] {
    const items: GalleryItem[] = [];
    for (let i = 1; i <= 10; i++) {
      items.push({
        src: `${this.baseUrl}/dojo/${i}.jpeg`,
        thumbnail: `${this.baseUrl}/dojo/tn_${i}.jpeg`,
      });
    }
    return items;
  }

  public getEveryDayItems(): GalleryItem[] {
    const items: GalleryItem[] = [];
    for (let i = 1; i <= 36; i++) {
      items.push({
        src: `${this.baseUrl}/everyday/${i}.jpg`,
        thumbnail: `${this.baseUrl}/everyday/tn_${i}.jpg`,
      });
    }
    return items;
  }

  public getAjpBern202409Items(): GalleryItem[] {
    const items: GalleryItem[] = [];
    for (let i = 1; i <= 17; i++) {
      items.push({
        src: `${this.baseUrl}/ajpbern202409/${i}.jpeg`,
        thumbnail: `${this.baseUrl}/ajpbern202409/tn_${i}.jpeg`,
      });
    }
    return items;
  }

  public getZao202410Items(): GalleryItem[] {
    const items: GalleryItem[] = [];
    for (let i = 1; i <= 28; i++) {
      items.push({
        src: `${this.baseUrl}/zao202410/${i}.jpeg`,
        thumbnail: `${this.baseUrl}/zao202410/tn_${i}.jpeg`,
      });
    }
    return items;
  }

  getGraduation2024Q4Items() {
    const items: GalleryItem[] = [];
    for (let i = 1; i <= 25; i++) {
      items.push({
        src: `${this.baseUrl}/graduation2024Q4/${i}.jpg`,
        thumbnail: `${this.baseUrl}/graduation2024Q4/tn_${i}.jpg`,
      });
    }
    return items;
  }
}
